import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';

import { products } from '../../services';
import { map } from 'lodash';
import { FreezeItem } from './'


class FreezeList extends Component {
  constructor() {
    super();
    this.state = { freezes: <div></div>, };
    this.deleteFreeze = this.deleteFreeze.bind(this);
  }

  componentDidMount() {
    this.getFreezesToDisplay()
  }
  componentDidUpdate(prevProps) {
   if (this.props.location !== prevProps.location) {
     this.onRouteChanged();
   }

 }
  getFreezesToDisplay(){
    const {rest, } = this.props;
    products.getFreezes(rest.computedMatch.params.userProductId)
      .then((res) => {
        this.setState({
          freezes: map(res.body.data.freezes, (freeze) => {
              return <FreezeItem Data={freeze} Delete={this.deleteFreeze}  key={freeze.id}  />
          })
        })
      }).catch(error => {
      console.log(error);
      });
  }
  deleteFreeze(productId, freezeId){
    products.deleteFutureFreeze(productId, freezeId)
    .then((res) => {
      this.getFreezesToDisplay()
      }).catch(error => {
    console.log(error);
    });
  }
  render() {
    return (
      <div id="invoice" className="col-lg-12">
        <h1 className="title">freezes</h1>
        <div className="row row-body"  >
          <div className="col-md-3 col-lg-2 hidden-sm-down">start</div>
          <div className="col-md-3">end</div>
          <div className="col-md-2 col-lg-3 hidden-sm-down"></div>
        </div>
        {this.state.freezes}
      </div>
    )
  }
};

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    payment: state.User.paymentMethod,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setInvoices: (invoices) => {
      dispatch(
        {
          type: 'SET_INVOICES',
          invoices: invoices,
        },
      );
    },
  }
}

FreezeList = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(FreezeList);


export default withRouter(FreezeList);



// WEBPACK FOOTER //
// ./src/components/Freeze/FreezesList.js